import React from "react"
import { Link, graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Image from "../components/image"
import SocialLinks from "../components/socialLinks"
import GetInTouch from "../components/getInTouch"
import { formatThoughtDate } from "../components/thoughts"
import thoughts from "../data/thoughts"
import "../components/thoughts.css"

const ThoughtTemplate = ({ data, pageContext }) => {
  const thought = thoughts.find(item => item.slug === pageContext.slug)
  const { pageData, svgFiles } = data
  const { home } = pageData.siteMetadata.pages

  if (!thought) {
    return null
  }

  const pathname = `/thoughts/${thought.slug}/`

  return (
    <Layout headerData={home} showThoughtsNav>
      <Link to="/music" className="ribbon slant-down">
        <div className="content">Music →</div>
      </Link>
      <SEO
        title={thought.title}
        description={thought.description}
        pathname={pathname}
        type="article"
        datePublished={thought.date}
        image={thought.image}
        keywords={[
          "Rahul Vagadiya",
          "product thinking",
          "AI",
          "building products",
        ]}
      />
      <SocialLinks
        svgFiles={svgFiles}
        links={pageData.siteMetadata.dev.links}
      />
      <GetInTouch />
      <hr />
      <article className="thought-page">
        <header className="thought-page-header">
          <time className="thought-date" dateTime={thought.date}>
            {formatThoughtDate(thought.date)}
          </time>
          <h1>{thought.title}</h1>
          <p>{thought.description}</p>
        </header>
        {thought.image && (
          <Image
            alt=""
            aria-hidden="true"
            fileName={thought.image}
            className="thought-image rv-rounded-md rv-overflow-hidden"
          />
        )}
        <div className="thought-page-content">
          {thought.body.map(paragraph => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </div>
        <Link className="thought-back-link" to="/thoughts/">
          ← All thoughts
        </Link>
      </article>
    </Layout>
  )
}

export const query = graphql`
  query ThoughtTemplateQuery {
    pageData: site {
      siteMetadata {
        pages {
          home {
            name
            description
          }
        }
        dev {
          links {
            name
            url
            filename
            tooltip
            icon
          }
        }
      }
    }
    svgFiles: allFile(filter: { extension: { eq: "svg" } }) {
      edges {
        node {
          publicURL
          name
        }
      }
    }
  }
`

export default ThoughtTemplate
